import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import NavigationTitle from '../components/global/NavigationTitle';
import ReportsScreen from '../components/reports/ReportsScreen';

export type ReportsStackParamList = {
  Reports: undefined;
};

const ReportsStack = createStackNavigator<ReportsStackParamList>();

const ReportsTab: React.ComponentType<any> = () => {
  const { t } = useTranslation(['home']);

  return (
    <ReportsStack.Navigator
      initialRouteName="Reports"
      screenOptions={{
        gestureEnabled: false,
        headerTintColor: '#ffffff',
        headerTitleAlign: 'center',
        headerStyle: {
          borderBottomWidth: 0,
          backgroundColor: '#3CD070',
          shadowColor: '#919191',
          shadowRadius: 5,
          shadowOpacity: 1,
          shadowOffset: { width: 1, height: 1 }
        },
        headerRight: () => <View />
      }}
    >
      <ReportsStack.Screen
        name="Reports"
        component={ReportsScreen}
        options={{
          headerTitle: () => <NavigationTitle defaultTintColor="white" title={t('home:reports.tabLabel')} />
        }}
      />
    </ReportsStack.Navigator>
  );
};

export default ReportsTab;
